import { render, staticRenderFns } from "./SrLabel.vue?vue&type=template&id=83f291e6"
import script from "./SrLabel.vue?vue&type=script&lang=js"
export * from "./SrLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports